import axios from "axios";
import authService, { ROLES_ENUM } from "./authService";
import { ManagedUser } from "../types";
import { SortBy } from "../common/components/Table/Table";

const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_ROUTE = "/api/v1/user/admin/users";

type ManagedUsersResponse = {
  data: {
    users: ManagedUser[];
    count: number;
  };
};

type ManagedUserResponse = {
  data: {
    user: ManagedUser;
  };
};

class AdminUserService {
  static async getUsers(
    pageNumber: number,
    rowsPerPage: number = 50,
    searchTerm: string = "",
    sortBy: SortBy | undefined
  ) {
    const res = await axios.post<ManagedUsersResponse>(
      `${BACKEND_BASE_URL}${BASE_ROUTE}`,
      { pageNumber, rowsPerPage, searchTerm, sortBy },
      authService.getAuthHeader()
    );
    return res.data.data;
  }

  static async updateUserRole(userId: string, role: ROLES_ENUM) {
    const res = await axios.put<ManagedUserResponse>(
      `${BACKEND_BASE_URL}${BASE_ROUTE}/${userId}/role`,
      { role },
      authService.getAuthHeader()
    );
    return res.data.data.user;
  }

  static async updateUserPriceTier(
    userId: string,
    priceTier: ManagedUser["priceTier"]
  ) {
    const res = await axios.put<ManagedUserResponse>(
      `${BACKEND_BASE_URL}${BASE_ROUTE}/${userId}/price-tier`,
      { priceTier },
      authService.getAuthHeader()
    );
    return res.data.data.user;
  }
}

export default AdminUserService;
